import { GridCellProps } from '@progress/kendo-react-grid';
import { DetailArrowIcon, ThreeDotIcon } from 'app/assets/icons';
import DropdownComponent from 'app/components/CustomFilterPopup';
import { usePermission } from 'hooks/usePermission';
import styled from 'styled-components';
interface ActionPermission {
  action: string;
  permissionId: string;
}
type Props = {
  className?: string;
  e?: GridCellProps;
  onMoreClick?: (item: any, e) => void;
  isAssigned?: boolean;
  onDataClick?: (data: any) => void;
  isRider?: boolean;
  isCoach?: boolean;
  isUser?: boolean;
  isCoachInsurance?: boolean;
  isCurrentSeason?: boolean;
  isPastDataFlag?: boolean;
};
const HorizontalKebabCell = ({
  className,
  e,
  onMoreClick,
  isAssigned,
  onDataClick,
  isRider = false,
  isCoach = false,
  isUser = false,
  isCurrentSeason = false,
  isCoachInsurance = false,
  isPastDataFlag,
}: Props) => {
  const { hasViewPermission } = usePermission();
  const data = e?.dataItem;
  const teamPermissions: ActionPermission[] = [
    { action: 'Make active', permissionId: '0200101010' },
    { action: 'Make inactive', permissionId: '0200101010' },
    { action: 'Edit team info', permissionId: '0200101009' },
    { action: 'Delete team', permissionId: '0200101011' },
  ];

  const riderPermissions: ActionPermission[] = [
    { action: 'Make active', permissionId: '0300101007' },
    { action: 'Make inactive', permissionId: '0300101007' },
    { action: 'Edit rider info', permissionId: '0300101006' },
    { action: 'Delete rider', permissionId: '0300101008' },
  ];

  const coachPermissions: ActionPermission[] = [
    { action: 'Make active', permissionId: '0400101005' },
    { action: 'Make inactive', permissionId: '0400101005' },
    { action: 'Edit coach info', permissionId: '0400101005' },
    { action: 'Delete coach', permissionId: '0400101006' },
  ];

  const userPermissions: ActionPermission[] = [
    { action: 'Edit user info', permissionId: '0100101005' },
    { action: 'Delete user', permissionId: '0100101007' },
  ];

  const seasonPermissions: ActionPermission[] = [
    { action: 'Make Active', permissionId: '0500101006' },
    { action: 'Make Inactive', permissionId: '0500101006' },
    { action: 'Duplicate Show', permissionId: '0500101007' },
    { action: 'Generate Split', permissionId: '0500101008' },
    { action: 'Edit Showinfo', permissionId: '0500101005' },
    { action: 'Delete Show', permissionId: '0500101015' },
    { action: 'Enter Results', permissionId: '0500101010' },
    { action: 'Class Order Reports', permissionId: '0700101011' },
    { action: 'Show Details', permissionId: '0700101012' },
    { action: 'Download Show Program', permissionId: '' },
  ];

  const coachInsurance: ActionPermission[] = [
    { action: 'Generate PDF', permissionId: '1200101005' },
    { action: 'View / Preview PDF', permissionId: '1200101005' },
    { action: 'Upload Edited PDF', permissionId: '1200101005' },
    { action: 'Send to Insurer', permissionId: '1200101005' },
  ];

  // Select appropriate permission set based on data type
  let actionPermissions: ActionPermission[];
  if (isCurrentSeason) {
    actionPermissions = seasonPermissions;
  } else if (isUser) {
    actionPermissions = userPermissions;
  } else if (isCoach) {
    actionPermissions = coachPermissions;
  } else if (isRider) {
    actionPermissions = riderPermissions;
  } else if (isCoachInsurance) {
    actionPermissions = coachInsurance;
  }else {
    actionPermissions = [{ action:"", permissionId:""}];
  }
  const permittedActions = actionPermissions
    .filter(item => hasViewPermission(item.permissionId))
    .map(item => item.action);
  let dropDowndata = permittedActions;
  if (data?.status?.name === 'Active') {
    dropDowndata = permittedActions.filter(item => item !== 'Make active');
  } else if (data?.status?.name === 'Inactive') {
    dropDowndata = permittedActions.filter(item => item !== 'Make inactive');
  }
  if (isCoachInsurance && !data?.isPdfGenerated) {
    dropDowndata = dropDowndata.filter(
      item =>
        item !== 'View / Preview PDF' &&
        item !== 'Upload Edited PDF' &&
        item !== 'Send to Insurer',
    );
  }
  const showDropdown = !isPastDataFlag && dropDowndata.length > 0;
  return (
    <StyledTd className={className ?? ''}>
      <Wrapper>
        {showDropdown ? (
          <DropdownComponent
            placement={'bottom-end'}
            data={dropDowndata}
            onDataClick={e => onDataClick?.(data)}
            onItemClick={item => {
              onMoreClick?.(item, e);
            }}
            svgIcon={<ThreeDotIcon />}
            className="custom-dropdown"
          />
        ) : null}
      </Wrapper>
    </StyledTd>
  );
};

export default HorizontalKebabCell;
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  position: absolute;
  height: 0;
  svg {
    transform: rotate(90deg);
  }
  .custom-dropdown {
    right: 0;
    top: 30px;
  }
  .k-button:hover::before {
    opacity: 0;
  }
  .filter-button button {
    border: none !important;
    width: 10px;
    padding: 5px;
    background-color: transparent !important;
    :hover {
      background: transparent !important;
      background-color: transparent !important;
      border: unset;
    }
  }
`;
const StyledTd = styled.td``;
